<template>
    <default-sidebar :active="$store.state.sidebars.showPersonalDocumentsCreateForm" :icon="sidebar.icon" :title="sidebar.title">
        <personal-documents-create-form v-if="$store.state.views.personal_document_categories.length && $store.state.sidebars.showPersonalDocumentsCreateForm"/>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
    import PersonalDocumentsCreateForm from "../forms/PersonalDocumentsCreateForm";

    export default {
        name: "PersonalDocumentsCreateFormSidebar",
        components: {
            DefaultSidebar,
            PersonalDocumentsCreateForm
        },
        data() {
            return {
                sidebar: {
                    icon: '<i class="fa-thin fa-id-card"></i>',
                    title: this.$t('cards.add_personal_document')
                }
            }
        },
    }
</script>

<style scoped lang="scss">

</style>